import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import CustomIcon from "../../../../../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import PathPickOrderDetailCard from "@/features/pathpick/features/order-history/features/detail/components/PathPickOrderDetailCard";
import {
  ORDER_DETAIL_KEY,
  ORDER_STEP_LABEL_KEYS,
} from "@/features/pathpick/features/order-history/features/detail/constants";
import { PathPickOrderStep } from "@/features/pathpick/features/order-history/features/detail/types";

interface Props {
  steps: PathPickOrderStep[];
}

// 주문 진행 상황 — 응답에 steps[]가 없어 toPathPickOrderSteps가 status로 파생한 단계를 그린다.
function PathPickOrderDetailStepper({ steps }: Props) {
  const { t } = useI18nHelper();

  return (
    <PathPickOrderDetailCard title={t(`${ORDER_DETAIL_KEY}progress_title`)}>
      <Flex>
        {steps.map((step, index) => {
          const isDone = step.state === "done";
          const isCurrent = step.state === "current";
          const isActive = isDone || isCurrent;

          return (
            <Flex
              key={step.code}
              flex={1}
              minWidth={0}
              flexDirection={"column"}
              alignItems={"center"}
              gap={"8px"}
              position={"relative"}
            >
              {/* 커넥터 (첫 노드 제외) — 이전 단계가 지나간 구간만 파랗게 채운다 */}
              {index > 0 && (
                <Box
                  position={"absolute"}
                  top={"11px"}
                  right={"50%"}
                  width={"100%"}
                  height={"2px"}
                  background={isActive ? "#1272EF" : "#EFEFED"}
                  zIndex={0}
                />
              )}
              <Flex
                boxSize={"24px"}
                borderRadius={"50%"}
                alignItems={"center"}
                justifyContent={"center"}
                zIndex={1}
                background={isDone ? "#1272EF" : "#FFFFFF"}
                border={
                  isDone
                    ? "none"
                    : `2px solid ${isCurrent ? "#1272EF" : "#D4D4D1"}`
                }
              >
                {isDone ? (
                  <CustomIcon
                    src={"check"}
                    width={14}
                    height={14}
                    color={"#FFFFFF"}
                  />
                ) : (
                  <Box
                    boxSize={"8px"}
                    borderRadius={"50%"}
                    background={isCurrent ? "#1272EF" : "#D4D4D1"}
                  />
                )}
              </Flex>
              <Text
                textStyle={isActive ? "caption-bold" : "caption-medium"}
                color={isActive ? "#1D1D1B" : "#8F8F8C"}
                textAlign={"center"}
                // 좁은 폭에서 노드 하나가 60px대로 줄어도 어절 단위로만 접히게 한다.
                wordBreak={{ base: "keep-all", md: "normal" }}
              >
                {t(ORDER_STEP_LABEL_KEYS[step.code])}
              </Text>
            </Flex>
          );
        })}
      </Flex>
    </PathPickOrderDetailCard>
  );
}

export default PathPickOrderDetailStepper;
